CT.messages = $.extend({
	pers : {
		errGeneric : '<p>Whoops! Cannot save preferences. Invalid key: {{jsonKey}}</p>'
	},
	hotel : {
		updating : "Updating hotels",
		errorTitle : "Please help us",
		unavailable : '{{#phoneSales}}Keen on booking? <strong><span class="icon phone"></span>Call {{phoneSales}}</strong>{{/phoneSales}}',
		youSave : "You save {{{d}}}",
		usp : {
			l : "Travellers love this hotel for its location.",
			c : "Travellers like this hotel due to its cleanliness.",
			v : "Travellers say this hotel offers great value."
		},
		cancellationPolicy : "Free cancellation up to 24 hours before checkin. 1 night <br>charges deducted if cancelled within 24 hours of checkin.",//Also in settings.js
		smartness : {
			shmsg: {
				tw: "this week",
				wl: "a week later",
				tom: "tomorrow",
				dat: "day after tomorrow",
				tod: "today"
			},
			user : {
				tw: "You've a trip this week",
				wl: "You've a trip next week",
				tom: "Your pillow awaits tomorrow",
				dat: "All set to check in day after",
				tod: "You've a trip today"
			},
			friend : {
				tw: "{{fn}} has a trip this week, remind {{pn}}",
				wl: "{{fn}} has a trip next week, remind {{pn}}",
				tom: "{{fn}} has a trip tomorrow, remind {{pn}}",
				dat: "{{fn}} has a trip day after, remind {{pn}}",
				tod: "{{fn}} has a trip today, remind {{pn}}"
			},
			notLoyalUser: {
				tit: "Welcome back! we missed you.",
				msg: "You've loads of stuff waiting for you.",
				btn: {
					name: "login",
					link: "http://www.cleartrip.com"
				}
			},
			callAssist: "{{#customerService}}Call for assistance {{customerService}}{{/customerService}}",
			processInDays: "5-7",
			refundTitle: "Your refund process is right on track",
			refundMsg: "Refund for trip id #{{tripId}}, {{tn}} will happen in {{days}} working days.",
			refundAmount: " Refund amount : {{{ramt}}}",
			cancelledTitle: "Your cancellation process is right on track",
			cancelledMsg: "Cancellation for trip id #{{tripId}}, {{tn}} will happen in {{days}} working days."
		},
		checkAvail :{

		},
		zeroResults: {
			filter: {
				title: "We couldn't find hotels to match your filters",
				msg: " or ",
				btnL: "Undo last filter",
				btnR: "Reset all filters",
				cls: "filters",
				btnLCls:"undoLastFilter primary",
				btnRCls:"resetLink"
			},
			genericError: {
				cls : "hotels",
				title: "Sorry, our system is acting up",
				subTitle: "This issue may be momentary. Please try again after sometime",
				btntxt: "Search again",
				btnlink: "/hotels"
			},
			zeroResult: {
				title: "Sorry, we couldn't find any hotels. Try a fresh search",
				cls: "hotels",
				btntxt: "Search again",
				btnlink: "/hotels"
			},
			Error400 : {
				cls : "hotels",
				title: "Looks like your dates are in the past",
				btntxt: "Try searching again",
				btnlink: "/hotels"
			},
			Error500 : {
				cls : "hotels",
				title: "Sorry, our servers are acting up",
				subTitle: "This issue may be momentary. Please try again",
				btntxt: "Search again",
				btnlink: "/hotels"
			},
			1: {
				zero: {
				title: "Sorry, we couldn't find any hotels",
				subTitle: "Seems like your travel dates are too far out. Consider dates that are closer",
				cls: "hotels",
				btntxt: "Modify search",
				btnlink: "/hotels"
				},
				few: {
				mainMsg: "You're missing out on some hotels since your dates are too far out"
				}
			},
			2: {
				zero: {
				title: "Sorry, we couldn't find any hotels",
				subTitle: "There's nothing available for such a long stay. Consider reducing length of your stay",
				cls: "hotels",
				btntxt: "Modify search",
				btnlink: "/hotels"
				},
				few: {
				mainMsg: "You're missing out on some hotels since your stay is too long"
				}
			},
			3: {
				zero: {
				title: "Sorry, we couldn't find any hotels",
				subTitle: "Getting so many rooms together is really hard. Consider reducing number of rooms",
				cls: "hotels",
				btntxt: "Modify search",
				btnlink: "/hotels"
				},
				few: {
				mainMsg: "Getting so many rooms together is hard. You might be missing out on some good hotels"
				}
			},
			4: {
				zero: {
				title: "Sorry, we couldn't find any hotels",
				subTitle: "There's no room available for more than 3 guests. Consider splitting into multiple rooms",
				cls: "hotels",
				btntxt: "Modify search",
				btnlink: "/hotels"
				},
				few: {
				mainMsg: "You're missing out on hotels that cannot accommodate so many guests in a room"
				}
			},
			5: {
				zero: {
				title: "Sorry, we couldn't find any hotels",
				subTitle: "You're trying to look for hotels on a really busy weekend. Consider travelling on weekdays",
				cls: "hotels",
				btntxt: "Modify search",
				btnlink: "/hotels"
				},
				few: {
				mainMsg: "Why miss out on great hotels because of a busy weekend? Try different dates"
				}
			},
			6: {
				zero: {
				title: "Sorry, we couldn't find any hotels. Try a fresh search",
				cls: "hotels",
				btntxt: "Search again",
				btnlink: "/hotels"
				},
				few: {
				mainMsg: "Oops! Looks like most hotels don't fit your needs"
				}
			},
			call: "{{#phoneSales}}Or call us on <span class='icon phone'></span><strong>{{phoneSales}}</strong>{{/phoneSales}}"
		},

		separatorMsgs: {
			localitySpecificSearch: {
				btnClass: "button action resetLink",
				btnAttr: "data-hidemessage=localityNotification",
				btnText: "Show all hotels in {{city}}"
			},
			hotelSpecificSearch: {
				btn: "Show all hotels in {{cityName}}",
				msg: "Want more options?",
				cls: "resetLink"
			},
			nearByCities: {
				mainMsg:  "{{localities}}",
				msg: "Showing hotels from nearby cities so that your options are not limited",
				closeBtnAttr: "data-hidemessage=nearByNotification data-close=.inpageMessage"
			},
			/*
			unavailable: {
				msg: "these are unavailable hotels"
			},
			radial: {
				msg: "Showing nearby hotels within 1.5 kms"
			},
			*/
			//TODO : move the markup to templates.shtml
			radialSeparator : 'Showing nearby hotels within 3 kms',
			unavailableSeparator : 'Other hotels that are currently unavailable'
		},
		moreFilters: "Show more filters",
		contentObj: {
			tit : "Being too picky?",
			msg : "There are 15 hotels in Karol Bagh, try easing your other filters"
		},
		pluralizeObj: [{
			key : "num_nights",
			s : "night",
			p : "nights"
		}, {
			key : "num_rooms",
			s : "room",
			p : "rooms"
		}, {
			key : "adults",
			s : "adult",
			p : "adults"
		}, {
			key : "childs",
			s : "child",
			p : "children"
		}, {
			key : "adults",
			s : "adult",
			p : "adults"
		}, {
			key : "infants",
			s : "infant",
			p : "infants"
		}],
		checkAvailability: "Check Availability",
		pkgCheapAir: "Showing packages with cheapest airline and ",
		dueToUnavailability: " due to unavailability of flights for both ways",
		SrchCountAudit: "Click for Search Count Audit",
		WIFIAccess: "Wi-Fi Access",
		Gym: "Gym",
		Pool: "Pool",
		BussinessCentre: "Business centre",
		InternetAccess: "Internet Access",
		RoomSrvc: "Room service",
		CoffeeShop: "Coffee shop",
		Bar: "Bar",
		Restaurant: "Restaurant",
		ChkIn24Hr: "24 Hour Check-in",
		AirConditioning: "Air Conditioning",
		OtherDestThm: "Other Destination Themes",
		OtherHotelThm: "Other Hotel Themes",
		MoreDestinations: "+ View more destinations",
		To: " to ",
		AnyRating: "Any rating",
		Rating: "Rating ",
		andAbove: " & above",
		StarTo: " Star to ",
		Star: " Star",
		Hour: "h",
		HourTo: "h to ",
		DriveTime: "Drive time: ",
		DriveTimeUpto: "Drive time: upto ",
		HotelToChoose: " hotels to choose from?</strong>2 quick questions to help you pinpoint your options</p>",
		Got: "<p><strong>Got",
		Eat: "Eat",
		NightLife: "Night Life",
		Sights: "Sights",
		Shopping: "Shopping",
		Gateways: "Getaways",
		Tophit: "Top hit",
		BestOf: "Best of ",
		Cities: "Cities",
		Locations: "Locations",
		Hotels: "Hotels",
		NotFound: "Not Found",
		WKGFrom: "Weekend getaways from ",
		BestMatch: "Best match",
		TopPickArea: "Top pick areas",
		Areas: "Areas",
		POInterest: "Point of Interest",
		More: "more",
		Less: "less",
		GatewaysFrom: "Getaways from ",
		From: "From",
		Where: "Where",
		SorryUnknwnLoc: "Sorry, this doesn't look like a city, area, landmark or a hotel.",
		ProvideChkInChkOut: "<h6>When would you like to stay?</h6><p><small class='weak'>Provide a check-in and check-out date</small></p>",
		LookingHotels: "Looking for hotels...",
		HotelLocNotFound: "Sorry, we don't have exact location details of this hotel",
		Reviews: " reviews",
		Review: " review",
		UnableToFindHotel: "Oops! we couldn't find hotels in this area",
		ShowingHotelsIn: "Showing hotels in",
		ShowingHotelsArnd: "Showing hotels around",
		ViewPricesInURWay: "<h6>Now view prices the way you want.</h6>",
		MakeLastMinPlan: "Making last minute plans?",
		GetExclusiveDeals: "Get exclusive hotel deals at the last minute with the Cleartrip app",
		LookForDealHotel: "Looking for a deal on hotel bookings?",
		getBestOfferDeals:"Get the best offers on flights and hotels with Cleartrip Mobile.",
		DoneLoading: 'All done!',
		TryFreshSearch: "<h6>Try a fresh search</h6>",
		Rooms: " rooms",
		Room: " room",
		Nights: " nights",
		Night: " night",
		NoLocInfo: "<span class='weak'>No location info</span>",
		ThingsToDo: " things to do",
		NoInfo: "<span class='weak'>No info</span>",
		shortlisted: "<span class='positive shortlisted'>shortlisted</span>",
		Shortlist: "Shortlist",
		B2B: {
			AG : {
				customerCareNumber : {
					'DOM' : 'For any assistance, please call 022 - 3035 1655  / 0730 443 2408 & Press Option 2 on IVR or mail to <a href="mailto:hotels.agentbox@cleartrip.com">hotels.agentbox@cleartrip.com</a>, <a href="mailto:agencysupport@cleartrip.com">agencysupport@cleartrip.com</a>.',
					'INTL' : 'For any assistance, please call 022 - 3035 1655  / 0730 443 2408 & Press Option 2 on IVR or mail to <a href="mailto:hotels.agentbox@cleartrip.com">hotels.agentbox@cleartrip.com</a>, <a href="mailto:agencysupport@cleartrip.com">agencysupport@cleartrip.com</a>.'
				}
			}
		}

	},
	dp : {
		zeroResults: {
			filter: {
				tit: "Oops! zero results found",
				msg: "Take load of your filters"
				/*
				msg: "Take load of your filters or &nbsp;",
				btn: "Undo last filter",
				"class": "undoFilter",
				call: true
				*/
			},
			zeroResult: {
				tit: "Oops, no flight + hotel found",
				msg: "Sorry, we could’t find any flight + hotel for the date and place you are looking for.",
				btn: "Modify your search",
				"class": "modifySearch primary",
				call: true
			},
			1: {
				tit: "Something seems to be wrong",
				msg: "You're travel date is too far off"
			},
			2: {
				tit: "Something seems to be wrong",
				msg: "You're length of stay is kind of making it difficult for us to suggest you a hotel",
				call: true
			},
			3: {
				tit: "Oops! no hotels found that fit your needs",
				msg: "Too many rooms. Try searching for another place or change your travel dates. That might help.",
				call: true
			},
			4: {
				tit: "Oops! no hotels found that fit your needs",
				msg: "Number of guests per room is more.",
				call: true
			},
			5: {
				tit: "Oops! no hotels found that fit your needs",
				msg: "Stay date is in a busy weekend.",
				call: true
			},
			6: {
				tit: "Oops!",
				msg: "very less or no hotels found that fits your needs.",
				call: true
			},
			call: "{{#phoneSales}}Or call us on <span class='icon phone'></span><strong>{{phoneSales}}</strong>{{/phoneSales}}"
		},
		blockMsgs: {
			6: {
				tit: "Being too picky?",
				msg: "There {{#single}}is{{/single}}{{^single}}are{{/single}} {{count}} {{#single}}hotel{{/single}}{{^single}}hotels{{/single}} {{#with}}with{{/with}}{{^with}}in{{/with}} {{name}}, try easing your other filters"
			}
		},
		separatorMsgs: {
			//property type filter enabled message upon clicking ptype in hotel list
			ptypeFilter: {
				msg: "property type filter enabled - {{ptype}}"
				/*
				btn: {
					"nm": "undo last filter",
					"class": "undoFilter"
				}
				*/
			},
			localityFilter: {
				msg: "Showing all hotels near {{area}}"
				/*
				btn: {
					"nm": "undo last filter",
					"class": "undoFilter"
				}
				*/
			},
			unavailable: {
				msg: "these are unavailable flights + hotels"
			},
			radial: {
				msg: "Showing nearby packages within 1.5 kms"
			}
		}

	}
}, CT.messages || {})

;
